import { useState } from "react"
import { FaRegEye, FaRegEyeSlash  } from "react-icons/fa";
import LogRenderTypesSCP from "../../Services/Data/SCP/LogRenderTypesSCP";

const HideShowField = ({field}) => {
    const [hidden, setHidden] = useState(true);

    let fieldData = field;

    if(typeof field === "string") {
        fieldData = {
            Value: field,
            RenderType: 0
        }
    }

    return (
        <div className="flex items-center gap-2">
            { hidden &&
                <>
                    <p>{fieldData.Value.replace(/[\s\S]/g, "*")}</p>
                    <FaRegEye onClick={() => setHidden(false)} className="hover:text-glmagenta-500"/>
                </>
            }
            { !hidden &&
                <>
                    {/* {text} */}
                    {LogRenderTypesSCP[fieldData.RenderType].render(fieldData)}
                    <FaRegEyeSlash onClick={() => setHidden(true)} className="hover:text-glmagenta-500"/>
                </>
            }       
        </div>
    )
}

export default HideShowField;